export const nextSubjectType = {
  last: 1,
  next: 0,
  current: 2
}

export const answerType = {
  'true': 'right',
  'false': 'incorrect'
}
